import { Component, Prop, Vue } from 'vue-property-decorator';
import PlantingList from '@/components/PlantingList/PlantingList.vue';
import PlantingDetail from '@/components/PlantingDetail/PlantingDetail.vue';

@Component({
    components: {
      PlantingList,
      PlantingDetail
    },
  })
export default class Planting extends Vue {
  @Prop()
  private id?: string

  private mode = ''
  private plantings: Array<string> = []
  created() {
    if(this.id) {
        this.mode = 'edit'
    }
  }

  getPlantings(plantings: Array<string>) {
      this.plantings = plantings
  }

}